import { z } from "zod"

/** Default page size for the work orders list (URL + API). */
export const WORK_ORDERS_LIST_DEFAULT_LIMIT = 20

export const getWorkOrderQueryParamsSchema = z.object({
    page: z.number().min(1).default(1),
    limit: z.number().min(1).max(100).default(WORK_ORDERS_LIST_DEFAULT_LIMIT),
    search: z.string().optional(),
    status: z.string().optional(),
    region: z.string().optional(),
    teamName: z.union([z.string(), z.array(z.string())]).optional(),
    delegateTo: z.string().optional(),
    workOrderType: z.union([z.string(), z.array(z.string())]).optional(),
    dateFrom: z.string().optional(),
    dateTo: z.string().optional(),
    progressMin: z.number().min(0).max(100).optional(),
    progressMax: z.number().min(0).max(100).optional(),
    sortBy: z.string().optional().default("createdAt"),
    sortOrder: z.enum(["asc", "desc"]).optional().default("desc"),
    // Column filters (HO-style)
    homeownerName: z.string().optional(),
    city: z.string().optional(),
    street: z.string().optional(),
    ownerId: z.string().optional(),
    createdDate: z.string().optional(),
})

export type GetWorkOrderQueryParamsType = z.infer<
    typeof getWorkOrderQueryParamsSchema
>

export const getWorkOrderQueryParamsWithOutPaginationSchema =
    getWorkOrderQueryParamsSchema.omit({
        page: true,
        limit: true,
    })

export type GetWorkOrderQueryParamsWithOutPaginationType = z.infer<
    typeof getWorkOrderQueryParamsWithOutPaginationSchema
>
